/*
 * Scroll-reveal (D60 §2.3) — ported dependency-free from the Next.js Reveal
 * component. One IntersectionObserver, fires once at 15% visibility. The start
 * state (opacity/translateY) is applied ONLY here by adding `.reveal-armed`, so
 * with JS off the content is visible from first paint. Under reduced-motion we
 * skip arming entirely — CSS also guards it, this just avoids the observer work.
 */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function init() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    // threshold 0: reveal as soon as ANY part of the element intersects. A
    // fixed fraction (e.g. 0.15) silently fails for elements taller than
    // viewport/fraction — a long article body (8000px+) can never show 15% at
    // once, so it stayed armed at opacity 0 forever. Any-pixel intersection is
    // height-independent and safe.
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0 });
    els.forEach(function (el) { el.classList.add('reveal-armed'); io.observe(el); });
    // Fail-safe: if anything is still armed shortly after load (observer never
    // fired for any reason), reveal it so content can never be trapped hidden.
    setTimeout(function () {
      document.querySelectorAll('.reveal-armed:not(.is-visible)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) el.classList.add('is-visible');
      });
    }, 1200);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
